export default __webpack_public_path__ + "media/images/search_16-d36b533af9b204f023255e0f6183953c.png";